"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _fireCustomEvent = _interopRequireDefault(require("@micado-digital/react-ui/utils/fireCustomEvent"));
var _CartContext = _interopRequireDefault(require("../../context/CartContext"));
var _ShopContext = _interopRequireDefault(require("../../context/ShopContext"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
var _Cart = _interopRequireDefault(require("../../components/Cart"));
var _Headline = _interopRequireDefault(require("../../components/views/Headline"));
var _Cart2 = _interopRequireDefault(require("./Cart01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Cart01 = _ref => {
  let {
    defaultLang = "de"
  } = _ref;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang: pageDataLang
  } = pageData || {};
  const {
    cart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    items = [],
    _loading = false
  } = cart || {};
  const [lang, setLang] = (0, _react.useState)(defaultLang);
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const css = (0, _Cart2.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    var _shopData$currency;
    if ((0, _isEmpty.default)(cart) || (0, _isEmpty.default)(shopData) || _loading) return;
    let items = [];
    let totalAmount = 0;
    const cartItems = cart === null || cart === void 0 ? void 0 : cart.items;
    if (!(0, _isEmpty.default)(cartItems)) {
      for (const cartItem of cartItems) {
        const {
          price: {
            amount
          } = {},
          quantity,
          title
        } = cartItem;
        totalAmount += amount;
        items.push({
          item_name: title,
          price: amount,
          quantity
        });
      }
    }
    (0, _fireCustomEvent.default)("view_cart", {
      ecommerce: {
        currency: shopData === null || shopData === void 0 || (_shopData$currency = shopData.currency) === null || _shopData$currency === void 0 ? void 0 : _shopData$currency.isoCode,
        value: totalAmount,
        items
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(cart), JSON.stringify(shopData)]);
  (0, _react.useEffect)(() => {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  const entries = (0, _react.useMemo)(() => {
    var _items$length;
    return (_items$length = items.length) !== null && _items$length !== void 0 ? _items$length : 0;
  }, [items]);
  return /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.cart, "mco-shop-cart"),
    maxWidth: "lg"
  }, entries > 0 && /*#__PURE__*/_react.default.createElement(_Headline.default, {
    headline: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.cart.headline",
      l: l
    }), entries > 0 && /*#__PURE__*/_react.default.createElement("span", {
      className: "mco-shop-headline__counter"
    }, " ", "(", entries, " ", entries === 1 ? /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.cart.labels.product",
      l: l
    }) : /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.cart.labels.products",
      l: l
    }), ")"))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: css.wrapper
  }, /*#__PURE__*/_react.default.createElement(_Cart.default, {
    lang: lang
  })));
};
Cart01.propTypes = {
  defaultLang: _propTypes.default.string
};
var _default = exports.default = Cart01;